import { makeApiRequestPromise } from "../../lib/api";

interface ImpersonationCustomer {
  domain: string;
}

/**
 * List customer domains a staff user may "view as". Staff-only on the backend
 * (403 otherwise). Returns [] on error so the picker degrades gracefully to
 * free-text entry.
 */
export const listImpersonationCustomers = async (): Promise<string[]> => {
  try {
    const rows: ImpersonationCustomer[] = await makeApiRequestPromise({
      path: "/api/v1/impersonation/customers",
      method: "GET",
    });
    return rows.map((r) => r.domain).sort();
  } catch (error) {
    console.error("Failed to list customers for impersonation:", error);
    return [];
  }
};
